const { analyticsEventBus, ANALYTICS_EVENTS } = require('../../events');
const { createEcommerceEventGA4 } = require('../models/ecommerceEventGA4');
const {
  createEcommerceEventItemsGA4,
} = require('../models/ecommerceEventItemsGA4');
const pushEvent = require('../pushEvent');
const { clickedItemListStorage } = require('../../stores/itemList');

/* -------------------------------------------------------------------------- *\
 * PRODUCT TILE EVENTS                                                        *
\* -------------------------------------------------------------------------- */

/**
 * Subscribe to our analytics events and push to dataLayers
 */
function subscribeToAnalyticsEvents() {
  analyticsEventBus.subscribe(
    ANALYTICS_EVENTS.productTileClicked,
    (payload) => {
      pushEvent(
        createEcommerceEventGA4(
          'select_item',
          createEcommerceEventItemsGA4([payload.product], {
            itemListStorage: clickedItemListStorage,
          })
        )
      );
    }
  );
}

module.exports = {
  subscribeToAnalyticsEvents,
};
